import * as React from 'react';
import { memo } from 'react';
import { useRecordContext } from 'ra-core';
import {
  Done,
  Clear,
  PendingActions,
  AutoDelete,
  Help,
} from '@mui/icons-material';
import { Button, Typography } from '@mui/material';

export const StatusField = memo((props) => {
  const { className, source } = props;
  const record = useRecordContext(props);
  const status = record[source];

  return (
    <Typography component="span" variant="body2" className={className}>
      <StatusIcon status={status} />
    </Typography>
  );
});

const StatusIcon = ({ status }) => {
  switch (status) {
    case 1:
      return (
        <Button
          color="primary"
          startIcon={<Done color="inherit" fontSize="small" />}
        >
          Opening
        </Button>
      );
    case 2:
      return (
        <Button
          color="secondary"
          startIcon={<PendingActions color="inherit" fontSize="small" />}
        >
          InActive
        </Button>
      );
    case 3:
      return (
        <Button
          color="error"
          startIcon={<Clear color="inherit" fontSize="small" />}
        >
          Closed
        </Button>
      );
    case 4:
      return (
        <Button
          color="inherit"
          startIcon={<AutoDelete color="inherit" fontSize="small" />}
        >
          Deleted
        </Button>
      );
    default:
      return (
        <Button
          color="warning"
          startIcon={<Help color="inherit" fontSize="small" />}
        >
          Unknown
        </Button>
      );
  }
};
